<template>
  <TitleWithBorderAtomStyled>
    {{ title }}
    <slot name="right" />
  </TitleWithBorderAtomStyled>
</template>

<script>
import { styled } from '@egoist/vue-emotion'

const TitleWithBorderAtomStyled = styled('div')`
  display: flex;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-bottom: solid 2px ${p => p.theme.colors.atomic.tableColumnHeaderBG};
  justify-content: space-between;
`

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  components: {
    TitleWithBorderAtomStyled,
  },
}
</script>
